import React from "react";
import { PageHelpContent } from "./PageHelpContent.jsx";

/** @typedef {import('../helpers/resolvePageHelp.js').PageHelpTopic} PageHelpTopic */

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {PageHelpTopic} props.topic
 * @param {React.ReactNode} [props.footer]
 * @param {string} [props.closeLabel]
 * @param {Partial<import('./PageHelpContent.jsx').PageHelpContent extends (p: infer P) => unknown ? never : never>} [props.labels]
 * @param {string} [props.testId]
 */
export function HelpDrawer({
  open,
  onClose,
  topic,
  footer,
  closeLabel = "Fermer",
  labels,
  testId = "cq-help-drawer",
}) {
  if (!open) return null;

  return (
    <div className="cq-help-overlay" data-testid={`${testId}-overlay`} onClick={onClose}>
      <aside
        className="cq-help-drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cq-help-drawer-title"
        data-testid={testId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cq-help-drawer__toolbar no-print">
          <button
            type="button"
            className="cq-help-drawer__close"
            onClick={onClose}
            data-testid="cq-help-drawer-close"
            aria-label={closeLabel}
          >
            ×
          </button>
        </div>
        <PageHelpContent topic={topic} labels={labels} />
        {footer ? <footer className="cq-help-drawer__footer no-print">{footer}</footer> : null}
      </aside>
    </div>
  );
}

/** @alias HelpDrawer */
export const HelpPanel = HelpDrawer;
